import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["onClickCapture"]

import TextareaButtonInterface, {
    isTextareaButtonInDropdown
} from "~/operatorApplication/vue/dialogs/dialog/textarea/TextareaButtonInterface";
import {provide, ref} from "vue";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ButtonsListConfigButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    buttons: {},
    hidePin: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;


let hideOnClick = ref(false);


provide(isTextareaButtonInDropdown, true);

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!

  return (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
    icon: "ellipsis-h",
    "dropdown-placement": "top-start",
    "is-config-button": "",
    "hide-on-click": _unref(hideOnClick)
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, { class: "overflow-hidden" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.buttons, (button) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (!button.hideInDropdown)
                ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: button.id,
                    class: _normalizeClass({
                            'w-100 d-flex config-button-dropdown-item': true,
                            'pr-0': !__props.hidePin
                        }),
                    onMouseover: () => { _isRef(hideOnClick) //@ts-ignore
 ? hideOnClick.value = !button.withDropdown : hideOnClick = !button.withDropdown; }
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(button.component), { class: "flex-fill button" })),
                      (!__props.hidePin)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "pl-3 pr-3 pin-container",
                            onClickCapture: _withModifiers(($event: any) => (_unref(OperatorApplicationConfigInstance).setTextareaButtonPinned(button.id, !_unref(OperatorApplicationConfigInstance).isTextareaButtonPinned(button.id))), ["stop"])
                          }, [
                            _createVNode(FontAwesomeIcon, {
                              class: "pin mr-0",
                              icon: "thumbtack",
                              light: !_unref(OperatorApplicationConfigInstance).isTextareaButtonPinned(button.id),
                              bold: _unref(OperatorApplicationConfigInstance).isTextareaButtonPinned(button.id)
                            }, null, 8, ["light", "bold"])
                          ], 40, _hoisted_1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["class", "onMouseover"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["hide-on-click"]))
}
}

})